import {loadYaml} from '@/script/common';

interface TextInfo { label: string; text: string; }

export default class TextManager {
  // シングルトン
  public static get INSTANCE(): TextManager {
    if (!TextManager._INSTANCE) {
      TextManager._INSTANCE = new TextManager();
    }
    return TextManager._INSTANCE;
  }
  private static _INSTANCE: TextManager;

  public textMap: TextInfo[] = [];

  // コンストラクタの隠蔽
  private constructor() {}

  public async init() {
    this.textMap = await loadYaml<TextInfo[]>('config/text.yaml');
  }

  public get(label: string) {
    const textInfo = this.textMap.filter((text) => text.label === label)[0];
    return textInfo ? textInfo.text : null;
  }
}
